import React from "react";
import "./Abouttawq.css";

export default function Abouttawq() {
  return (
    <div className="tawqabout-wrapper pb-5 mt-3 pb-5" >
      <div className="container  pb-5 mt-5 mb-5 ">

        <h1 className="about-title mt-5 pt-5 ">من نحن؟ </h1>

        <div className="about-card mb-5 pb-5">

          <h2>من نحن؟</h2>
          <p>
            طوق نجاة هو منصة تسوق إلكترونية تهدف إلى تسهيل عملية البيع والشراء في
            مكان واحد آمن وسهل الاستخدام. نسعى إلى ربط البائع بالمشتري بكل شفافية
            وسرعة.
          </p>

          <h2>رؤيتنا</h2>
          <p>
            أن نكون الوجهة الأولى للتسوق الإلكتروني الموثوق في الوطن العربي.
          </p>

          <h2>رسالتنا</h2>
          <p>
            تقديم تجربة تسوق مريحة، منتجات متنوعة، وأسعار تنافسية مع دعم فني دائم.
          </p>

          <h2>لماذا طوق نجاة؟</h2>
          <ul>
            <li>✅ تنوع كبير في المنتجات</li>
            <li>✅ بائعين موثوقين</li>
            <li>✅ طرق دفع آمنة</li>
            <li>✅ دعم فني سريع</li>
          </ul>

        </div>

      </div>
    </div>
  );
}
